<template>
 <div class="">
  <apexchart width="100%" :options="chartOptions" :series="series" />
 </div>
</template>

<script>
export default {
 name: "RadialBarChart",
 props: {
  series: {
   type: Array,
   required: true,
  },
  labels: {
   type: Array,
   default: () => ["Queue Connection %", "Availability %", "PBX Connection %"],
  },
  title: {
   type: String,
   default: "Performance Metrics",
  },
 },
 data() {
  return {
   series: this.series,
   chartOptions: {
    chart: {
     type: "radialBar",
    },
    plotOptions: {
     radialBar: {
      dataLabels: {
       name: {
        fontSize: "16px",
        color: "#374151",
       },
       value: {
        fontSize: "20px",
        fontWeight: "bold",
        color: "#1f2937",
        formatter: function (val) {
         return parseInt(val).toFixed(0) + "%";
        },
       },
       total: {
        show: true,
        label: "Available",
        color: "#6b7280",
        formatter: function (val) {
         return parseInt(val?.config?.series[0]).toFixed(0) + "%";
        },
       },
      },
     },
    },
    title: {
     text: this.title,
     align: "left",
     style: {
      fontSize: "16px",
      color: "#333",
     },
    },
    subtitle: {
     text: this.$t("userStatusDistribution"),
    },
    labels: this.labels,
   },
  };
 },
 computed: {},
};
</script>
